(function () {
  function selectElement(selector, node) {
    return (node || document).querySelector(selector) || {};
  }

  function getCustomFields() {
    const elements = document.querySelectorAll(".mxpr-custom-field");
    const customFields = {}
    elements.forEach(elm => {
      if (elm.type == "checkbox") {
        if (elm.checked) {
          const values = customFields[elm.name] ?.value || [];
          values.push(elm.value);
          customFields[elm.name] = { value: values }
        }
      } else {
        customFields[elm.name] = { value: elm.value }
      }
    });
    return customFields;
  }

  async function submitReview(productId, customerId) {
    const customFields = getCustomFields();
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        review: {
          productId: productId,
          customerId: customerId,
          rating: selectElement("#mxpr-form__rating").value,
          name: selectElement("#mxpr-form__name").value,
          email: selectElement("#mxpr-form__email").value,
          guest: customerId ? false : true,
          title: selectElement("#mxpr-form__title").value,
          body: selectElement("#mxpr-form__body").value,
          customFields: customFields
        },
      }),
    };

    return await fetch("/tools/prime-review/api/postReview", fetchOptions);
  }

  // 入力チェック。エラーの場合は true を返す
  function checkInput() {
    const review = {
      name: selectElement("#mxpr-form__name").value,
      title: selectElement("#mxpr-form__title").value,
      body: selectElement("#mxpr-form__body").value,
      email: selectElement("#mxpr-form__email").value,
      email_required: selectElement("#mxpr-form__email").required,
      customFields1: selectElement("#mxpr-form__custom_field_1").value,
      customFields2: selectElement("#mxpr-form__custom_field_2").value,
      customFields3: selectElement("#mxpr-form__custom_field_3").value
    };
    const alerts = document.getElementsByClassName("mxpr-form-alert-message");
    for (let i = 0; i < alerts.length; i++) {
      alerts[i].style.display = "none";
    }
    if (!review.customFields1){
      document.getElementById("mxpr-form__custom_field_1").focus();
      document.getElementById("mxpr-form__custom_field_1-alert").style.display = "block";
    } else if (!review.customFields2 && document.getElementById('mxpr-form__custom_field_2')) {
      document.getElementById("mxpr-form__custom_field_2").focus();
      document.getElementById("mxpr-form__custom_field_2-alert").style.display = "block";
    } else if (!review.customFields3) {
      document.getElementById("mxpr-form__custom_field_3").focus();
      document.getElementById("mxpr-form__custom_field_3-alert").style.display = "block";
    } else if (!review.name) {
      document.getElementById("mxpr-form__name").focus();
      document.getElementById("mxpr-form__name-alert").style.display = "block";
    } else if (review.email_required && !review.email) {
      document.getElementById("mxpr-form__email").focus();
      document.getElementById("mxpr-form__email-alert").style.display = "block";
    } else if (!review.title) {
      document.getElementById("mxpr-form__title").focus();
      document.getElementById("mxpr-form__title-alert").style.display = "block";
    } else if (!review.body) {
      document.getElementById("mxpr-form__body").focus();
      document.getElementById("mxpr-form__body-alert").style.display = "block";
    } else if (review.body.length < 5) {
      document.getElementById("mxpr-form__body").focus();
      document.getElementById("mxpr-form__body-alert-short").style.display = "block";
    } else if (review.body.length > 4000) {
      document.getElementById("mxpr-form__body").focus();
      document.getElementById("mxpr-form__body-alert-long").style.display = "block";
    } else {
      const elements = document.querySelectorAll(".mxpr-custom-field");
      const customFields = {}
      elements.forEach(elm => {
        if (elm.type == "checkbox") {
          const values = customFields[elm.name] ?.value || [];
          if (elm.checked) {
            values.push(elm.value);
          }
          customFields[elm.name] = { value: values }
        }
      });
      let existRequireFails = false;
      Object.keys(customFields).forEach(key => {
        const validationElement = document.getElementById(`mxpr-choicelist-${key}`)
        if (validationElement.dataset.required == "true") {
          if (customFields[key].value.length == 0) {
            alert(`${validationElement.dataset.validationPrefix}${validationElement.dataset.fieldName}${validationElement.dataset.validationSuffix}`)
            existRequireFails = true;
          }
        }
      });
      if (!existRequireFails) {
        return false;
      }
    }

    return true;
  }

  function initWriteReview({ target }) {
    const rootBlock = target.closest(".mxpr-block[data-product-id]");
    const { productId, customerId } = rootBlock.dataset;
    if (!customerId) {
      if (!window.PrimeReviewSettings ?.reviewAllowGuest) {
        if (confirm(target.dataset.alert)) {
          location.href = `/account/login?checkout_url=${window.location.pathname}`;
        }
        return;
      }
      // メールアドレス入力欄を表示
      const emailArea = document.getElementById("email-field-for-guest");
      if (emailArea) {
        emailArea.style.display = "block";
      }
      if (window.PrimeReviewSettings ?.emailRequired) {
        const emailField = document.getElementById("mxpr-form__email");
        if (emailField) {
          emailField.required = "true";
        }
      }
    }
    const el = target.parentNode.classList.contains(
      "mxpr-summary__no-reviews"
    )
      ? target.parentNode
      : target;
    el.parentNode.removeChild(el);

    const form = document.getElementById("mxpr-product-reviews-form");
    const submitButton = document.getElementById("mxpr-form-submit-button");
    form.style.display = "flex";

    submitButton.addEventListener("click", async (event) => {
      event.preventDefault();
      const errorMessage = document.getElementById("mxpr-form-message-error");
      errorMessage.style.display = "none";

      if (checkInput()) {
        return;
      }

      const submitButton = document.getElementById("mxpr-form-submit-button");
      const submitMessage = document.getElementById("mxpr-form-submit-message");
      const submitLoading = document.getElementById("mxpr-form-submit-loading");
      const originalButtonCaption = submitMessage.innerText;
      submitButton.disabled = true;
      submitMessage.innerText = submitButton.dataset.sending;
      submitButton.classList.add("mxpr-form__submit--loading");
      //submitLoading.style.display = "block";

      selectElement("#mxpr-form__name").disabled = true;
      selectElement("#mxpr-form__email").disabled = true;
      selectElement("#mxpr-form__title").disabled = true;
      selectElement("#mxpr-form__body").disabled = true;
      selectElement("#mxpr-form__rating").disabled = true;

      const result = await submitReview(productId, customerId);

      if (result.status === 200) {
        form.style.display = "none";
        const thankyou = document.getElementById("mxpr-form-message-thankyou");
        thankyou.style.display = "flex";
      } else {
        errorMessage.style.display = "flex";
        selectElement("#mxpr-form__name").disabled = false;
        selectElement("#mxpr-form__title").disabled = false;
        selectElement("#mxpr-form__body").disabled = false;
        selectElement("#mxpr-form__rating").disabled = false;
      }

    });

  }

  function resizeTextarea({ target }) {
    const PADDING_Y = 20;
    const $textarea = document.getElementById("textarea");
    let lineHeight = getComputedStyle(target).lineHeight;
    lineHeight = lineHeight.replace(/[^-\d\.]/g, '') || 24;
    const lines = (target.value + '\n').match(/\n/g).length;
    const height = lineHeight * lines + PADDING_Y;
    if (height > 70) {
      target.style.height = height + 'px';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const writeReviewButton = document.querySelector("#only-form");
    if (writeReviewButton ) {
      writeReviewButton.click();
    }
  });
  document.querySelector(".mxpr-summary__write-review").addEventListener("click", initWriteReview);
  document.querySelector("#mxpr-form__body").addEventListener("input", resizeTextarea);

  const textareas = document.querySelectorAll(".mxpr-text-area");
  textareas.forEach(textarea => textarea.addEventListener("input", resizeTextarea));

})();
